import React, { useState, useEffect, useContext } from "react";
import {
  Nav,
  Navbar,
  Container,
  Button,
  Modal,
  ProgressBar,
} from "react-bootstrap";

import { Utils, UserContext } from "./../../common";
import _ from "lodash";
import moment from "moment";
import axios from "axios";

const hasAnyPath = (pathary) => {
  return (
    _.filter(pathary, (path) => window.location.pathname.indexOf(path) > -1)
      .length > 0
  );
};

const activeClass = (bool) => {
  return bool ? "py-2 active" : "py-2";
};

const varmenu = {
  dashboard: ["dashboard"],
  timehub: ["attendance", "myrota", "leave"],
  workflow: ["jobs", "todo"],
  training: ["cpd", "resources", "help-materials"],
  performance: ["reports", "evidences"],
  adminc: ["comrota", "users", "cqc", "userdocument", "myprofile"],
};

const pageLoadedMenu = () => {
  var val = "";
  _.each(varmenu, (ary, key) => {
    if (hasAnyPath(ary)) val = key;
  });
  return val;
};

const imageState = (nm) => {
  var src = process.env.PUBLIC_URL + "/images/" + nm;

  if (!hasAnyPath(varmenu[nm])) {
    src += "-d";
  }
  src += ".png";
  return (
    <img
      src={src}
      style={{ marginRight: "18px !important", marginLeft: "10px" }}
      width="19"
      alt={nm}
    />
  );
};

const Header = (props) => {
  const [showLogout, setShowLogout] = useState(false);
  const [nowTime, setNowTime] = useState(moment().format("HH:mm:ss"));

  const { userData, addToUserData, goTraining, showPlan, setShowPlan, setShowHowToModal } =
    useContext(UserContext);
  const [training, setTraining] = useState(false);
  const [openMenu, setOpenMenu] = useState(pageLoadedMenu());

  const isSuper = Boolean(userData?.is_super_user === true || userData?.is_super_user === 1 || userData?.is_super_user === "1" || userData?.is_super_user === "true");
  const isManager = Boolean(isSuper || userData?.manager === true || userData?.manager === 1 || userData?.manager === "1" || userData?.manager === "true");

  useEffect(() => {
    const timer = setInterval(() => {
      setNowTime(moment().format("HH:mm:ss"));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (Utils.isLoggedIn() && !_.get(userData, "braname") && !_.get(userData, "branch_name")) {
      axios.get(Utils.apiUrl("users/fetchbranches"), Utils.apiHeaders())
        .then((res) => {
          const data = Utils.parseApiResponse(res);
          if (data.success && data.branches && data.branches.length > 0) {
            const userBra = data.branches.find(b => String(b.id) === String(userData.branch_id)) || data.branches[0];
            if (userBra && userBra.name) {
              addToUserData({ braname: userBra.name, branch_name: userBra.name });
            }
          }
        }).catch(() => {});
    }
  }, []);

  if (!Utils.isLoggedIn()) {
    window.location.href = process.env.PUBLIC_URL + "/login";
  }

  const handleGoTraining = (e) => {
    setTraining(true);
    goTraining()
      .then(() => setTraining(false))
      .catch(() => setTraining(false));
  };

  const isActive = (path) => {
    if (window.location.pathname.indexOf(path) > -1) {
      return "active";
    } else {
      return "";
    }
  };

  const getLogo = () => {
    const uData = Utils.getUserData() || userData || {};
    const logo = _.get(uData, "orglogo") || _.get(uData, "logo") || _.get(uData, "org_logo") || _.get(uData, "practice_logo") || _.get(userData, "orglogo") || _.get(userData, "logo") || _.get(userData, "org_logo") || _.get(userData, "practice_logo") || "";
    return Utils.getLogoUrl(logo);
  };

  const count = (p) => {
    return parseInt(_.get(Utils.getUserData(), p, 0));
  };

  const remainingThings = () => {
    const j = count("jobs");
    const t = count("tasks");
    let tmp = [];
    if (j > 0) {
      tmp.push(`${j} job${j > 1 ? "s" : ""}`);
    }
    if (t > 0) {
      tmp.push(`${t} To Do`);
    }

    if (tmp.length > 0) {
      return (
        <h5 className="text-blue">
          <b>You have {tmp.join(" and ")} pending.</b>
        </h5>
      );
    } else {
      return <></>;
    }
  };

  const logMeOut = () => {
    window.location.href = `${process.env.PUBLIC_URL}/logout`;
  };

  const confirmLogout = () => {
    return (
      <Modal show={showLogout} centered>
        <Modal.Header style={{ borderBottom: "0" }} className="pb-0 mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/close.png`}
            className="ms-auto clickable"
            title="Close"
            alt="Close"
            onClick={() => setShowLogout(false)}
          />
        </Modal.Header>
        <Modal.Body className="bg-white text-center px-5">
          <img
            src={`${process.env.PUBLIC_URL}/images/alert.png`}
            className="mb-3"
            alt="Information"
          />
          {remainingThings()}
          <h4 className="text-danger mt-3">
            <b>Are you sure you want to logout?</b>
          </h4>
          <Button
            variant="primary"
            className="d-block mx-auto mt-4 w-100"
            onClick={() => setShowLogout(false)}
          >
            No
            {(count("jobs") > 0 || count("tasks")) > 0 && (
              <>. I will complete the job</>
            )}
          </Button>
          <Button
            variant="outline-danger"
            className="d-block mx-auto mt-2 mb-4 w-100"
            onClick={logMeOut}
          >
            Yes
          </Button>
        </Modal.Body>
      </Modal>
    );
  };

  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 1030 }}>
      <header className="topbar" style={{ position: "sticky", top: 0, zIndex: 1030, background: "#FFFFFF" }}>
        <div className="d-flex align-items-center gap-3">
          <div className="topbar__place" title={_.get(userData, "braname") || _.get(userData, "branch_name") || _.get(userData, "practice_name") || _.get(userData, "orgname") || "Branch"}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21s7-5.7 7-11a7 7 0 1 0-14 0c0 5.3 7 11 7 11Z"/><circle cx="12" cy="10" r="2.4"/></svg>
            <span>{_.get(userData, "braname") || _.get(userData, "branch_name") || _.get(userData, "practice_name") || _.get(userData, "orgname") || "Main Branch"}</span>
          </div>
          <div className="topbar__sep d-none d-md-block"></div>
          {/* Live Practice Time Chip */}
          <div className="shiftchip d-none d-sm-flex" title="Current Practice Time">
            <div className="shiftchip__face" style={{ background: "rgba(89, 147, 212, 0.2)", color: "var(--dt-blue)" }}>
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 1.9"/></svg>
            </div>
            <div>
              <div className="shiftchip__t num">{nowTime}</div>
            </div>
            <span className="shiftchip__lbl" style={{ color: "#94A3B8" }}>{moment().format("ddd, DD MMM")}</span>
          </div>
        </div>

        <div className="topbar__spacer"></div>

        {/* Right side controls */}
        {Utils.isLoggedIn() && (
          <div className="d-flex align-items-center gap-3">
            {isSuper && _.get(userData, "plan_expires", false) !== false && (
              <button 
                className="dt-btn dt-btn--ghost py-1 px-3 d-none d-sm-inline-flex"
                onClick={() => setShowPlan(!showPlan)}
                style={{ fontSize: "12px" }}
              >
                <span>{showPlan ? "Hide" : "View"} Plan</span>
              </button>
            )}

            {/* Notification Bell */}
            <button 
              className="iconbtn notifyctrl position-relative"
              onClick={() => props.setShowNoti(!props.showNoti)}
              title={props.notiData?.length > 0 ? `${props.notiData.length} new notifications` : "No new notifications"}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8.5a6 6 0 1 0-12 0c0 5-2 6.5-2 6.5h16s-2-1.5-2-6.5Z"/><path d="M13.7 19a2 2 0 0 1-3.4 0"/></svg>
              {props.notiData && props.notiData.length > 0 && (
                <span 
                  className="badge rounded-pill bg-danger" 
                  style={{ 
                    position: "absolute",
                    top: "2px",
                    right: "2px",
                    fontSize: "9.5px", 
                    padding: "2px 5px",
                    lineHeight: "1",
                    fontWeight: 700,
                    boxShadow: "0 0 0 2px #ffffff"
                  }}
                >
                  {props.notiData.length}
                </span>
              )}
            </button>

            {/* User Profile Pill */}
            <button className="who d-none d-md-flex" onClick={() => setShowLogout(true)} title="Click to Logout">
              <span className="who__face">
                {_.get(userData, "name", "D").charAt(0).toUpperCase()}
              </span>
              <span style={{ textAlign: "left" }}>
                <span className="who__name">{userData.name}</span>
                <span className="who__role d-block">{_.get(userData, "designation", "Staff Member")}</span>
              </span>
            </button>

            {/* Prominent Topbar Logout Button */}
            <button
              className="dt-btn dt-btn--ghost d-inline-flex align-items-center gap-1 py-1 px-3"
              onClick={() => setShowLogout(true)}
              style={{ fontSize: "12.5px", color: "var(--coral)", border: "1px solid rgba(220, 38, 38, 0.25)", borderRadius: "8px" }}
              title="Sign Out"
            >
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
              <span>Logout</span>
            </button>

            {/* Mobile / Tablet Hamburger Button */}
            <button
              id="dt-mobile-hamburger-btn"
              className="iconbtn d-lg-none"
              onClick={() => setMobileDrawerOpen(!mobileDrawerOpen)}
              title="Menu"
              style={{ width: 36, height: 36 }}
            >
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                {mobileDrawerOpen ? (
                  <path d="M18 6 6 18M6 6l12 12" />
                ) : (
                  <path d="M4 12h16M4 6h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        )}
      </header>

      {/* Slide-in Modern Mobile Drawer */}
      {mobileDrawerOpen && (
        <>
          <div className="dt-mobile-backdrop" onClick={() => setMobileDrawerOpen(false)} />
          <nav className="dt-mobile-drawer" aria-label="Mobile Drawer Navigation">
            {/* Header: Practice Logo on Top, User Card Below */}
            <div className="p-3 border-bottom" style={{ background: "linear-gradient(135deg, #181059 0%, #0d0838 100%)", color: "#FFFFFF" }}>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="bg-white p-2 rounded d-flex align-items-center justify-content-center shadow-sm" style={{ minWidth: 90, maxWidth: 150, height: 42 }}>
                  <img
                    src={getLogo()}
                    alt="Practice Logo"
                    style={{ maxHeight: 30, maxWidth: 135, objectFit: "contain" }}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = process.env.PUBLIC_URL + "/images/logo.png";
                    }}
                  />
                </div>
                <button
                  className="btn-close btn-close-white"
                  onClick={() => setMobileDrawerOpen(false)}
                  aria-label="Close"
                />
              </div>
              <div className="d-flex align-items-center gap-2 pt-2 border-top border-white border-opacity-10">
                <div className="who__face" style={{ width: 34, height: 34, fontSize: "14px", flexShrink: 0 }}>
                  {_.get(userData, "name", "D").charAt(0).toUpperCase()}
                </div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div className="fw-bold text-truncate" style={{ fontSize: "13.5px", color: "#FFFFFF" }}>{userData.name}</div>
                  <div className="text-truncate" style={{ fontSize: "11px", color: "rgba(255,255,255,0.75)" }}>
                    {_.get(userData, "designation", "Staff Member")} &bull; {_.get(userData, "braname") || _.get(userData, "branch_name") || _.get(userData, "practice_name") || _.get(userData, "orgname") || "DenTTrack"}
                  </div>
                </div>
              </div>
            </div>

            {/* Scrollable Nav List */}
            <div className="p-3 d-flex flex-column gap-3 overflow-y-auto" style={{ flex: 1 }}>
              {/* Group: Overview */}
              <div>
                <div className="text-uppercase text-muted fw-bold px-2 mb-1" style={{ fontSize: "10.5px", letterSpacing: "0.06em" }}>
                  Overview
                </div>
                {(userData.is_super_user || Utils.hasAccess(1)) && (
                  <a href={`${process.env.PUBLIC_URL}/dashboard`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></svg>
                    <span>Dashboard</span>
                  </a>
                )}
              </div>

              {/* Group: Time Hub */}
              {(userData.is_super_user || Utils.hasAccess(2) || Utils.hasAccess(5)) && (
                <div>
                  <div className="text-uppercase text-muted fw-bold px-2 mb-1" style={{ fontSize: "10.5px", letterSpacing: "0.06em" }}>
                    Time Hub
                  </div>
                  {(userData.is_super_user || Utils.hasAccess(2)) && (
                    <a href={`${process.env.PUBLIC_URL}/attendance`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 1.9"/></svg>
                      <span>Attendance</span>
                    </a>
                  )}
                  {(userData.is_super_user || Utils.hasAccess(2)) && (
                    <a href={`${process.env.PUBLIC_URL}/myrota`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                      <span>My Rota</span>
                    </a>
                  )}
                  {(userData.is_super_user || Utils.hasAccess(5)) && (
                    <a href={`${process.env.PUBLIC_URL}/leave`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg>
                      <span>Holidays</span>
                    </a>
                  )}
                </div>
              )}

              {/* Group: Clinical Workflow */}
              {(userData.is_super_user || Utils.hasAccess(3) || Utils.hasAccess(4)) && (
                <div>
                  <div className="text-uppercase text-muted fw-bold px-2 mb-1" style={{ fontSize: "10.5px", letterSpacing: "0.06em" }}>
                    Clinical Workflow
                  </div>
                  {(userData.is_super_user || Utils.hasAccess(3)) && (
                    <a href={`${process.env.PUBLIC_URL}/jobs`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 4h6a1 1 0 0 1 1 1v1H8V5a1 1 0 0 1 1-1Z"/><rect x="4" y="6" width="16" height="15" rx="2"/><path d="M9 12h6M9 16h4"/></svg>
                      <span>Jobs Outlook</span>
                    </a>
                  )}
                  {(userData.is_super_user || Utils.hasAccess(4)) && (
                    <a href={`${process.env.PUBLIC_URL}/todo`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7"/></svg>
                      <span>Tasks Outlook</span>
                    </a>
                  )}
                </div>
              )}

              {/* Group: CQC Intelligence */}
              {(userData.is_cqc || (userData.is_super_user && Utils.hasAccess(11))) && (
                <div>
                  <div className="text-uppercase text-muted fw-bold px-2 mb-1" style={{ fontSize: "10.5px", letterSpacing: "0.06em" }}>
                    Compliance &amp; Quality
                  </div>
                  <a href={`${process.env.PUBLIC_URL}/cqc`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3.2 4.5 6v5.6c0 4.4 3 8.2 7.5 9.4 4.5-1.2 7.5-5 7.5-9.4V6L12 3.2Z"/><path d="m9.2 12 2 2 3.6-3.8"/></svg>
                    <span>CQC Intelligence</span>
                  </a>
                </div>
              )}

              {/* Group: Team & Master Rota */}
              {(userData.is_rota || isSuper || Utils.hasAccess(12)) && (
                <div>
                  <div className="text-uppercase text-muted fw-bold px-2 mb-1" style={{ fontSize: "10.5px", letterSpacing: "0.06em" }}>
                    Staff &amp; Administration
                  </div>
                  {(userData.is_rota || isSuper || Utils.hasAccess(12)) && (
                    <a href={`${process.env.PUBLIC_URL}/comrota`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                      <span>Master Rota</span>
                    </a>
                  )}
                  {isSuper && (
                    <a href={`${process.env.PUBLIC_URL}/users`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M3.5 20c0-3.2 2.5-5.5 5.5-5.5s5.5 2.3 5.5 5.5"/><path d="M16.5 5.5a3 3 0 0 1 0 5.6M18 20c0-2.2-.7-4-1.9-5.2"/></svg>
                      <span>Team Members</span>
                    </a>
                  )}
                </div>
              )}

              {/* Group: Training & CPD */}
              <div>
                <div className="text-uppercase text-muted fw-bold px-2 mb-1" style={{ fontSize: "10.5px", letterSpacing: "0.06em" }}>
                  Learning &amp; Training
                </div>
                <button
                  type="button"
                  className="dt-mobile-link w-100 text-start btn-reset"
                  onClick={(e) => {
                    e.preventDefault();
                    setMobileDrawerOpen(false);
                    handleGoTraining(e);
                  }}
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                  <span>{training ? "Opening CPD..." : "CPD Portal"}</span>
                </button>
                <a href={`${process.env.PUBLIC_URL}/resources`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                  <span>Resources</span>
                </a>
                <button
                  type="button"
                  className="dt-mobile-link w-100 text-start btn-reset"
                  onClick={() => {
                    setMobileDrawerOpen(false);
                    if (setShowHowToModal) setShowHowToModal(true);
                  }}
                >
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8"/></svg>
                  <span>How To Guides</span>
                </button>
                {isSuper && (
                  <a href={`${process.env.PUBLIC_URL}/helpmat`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    <span>Manage Help Guides</span>
                  </a>
                )}
              </div>

              {/* Group: Reports & Performance */}
              {(isSuper || Utils.hasAccess(7)) && (
                <div>
                  <div className="text-uppercase text-muted fw-bold px-2 mb-1" style={{ fontSize: "10.5px", letterSpacing: "0.06em" }}>
                    Performance
                  </div>
                  <a href={`${process.env.PUBLIC_URL}/reports`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 20V10M12 20V4M6 20v-6"/></svg>
                    <span>Performance Reports</span>
                  </a>
                  <a href={`${process.env.PUBLIC_URL}/evidences`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                    <span>Evidences</span>
                  </a>
                </div>
              )}

              {/* Group: Profile Docs */}
              <div>
                <div className="text-uppercase text-muted fw-bold px-2 mb-1" style={{ fontSize: "10.5px", letterSpacing: "0.06em" }}>
                  Profile Docs
                </div>
                {isSuper ? (
                  <>
                    <a href={`${process.env.PUBLIC_URL}/myprofile`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 7 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 7 2.6h.1A2 2 0 0 1 9 1h.1" transform="translate(2 2) scale(.86)"/></svg>
                      <span>My Profile &amp; Settings</span>
                    </a>
                    <a href={`${process.env.PUBLIC_URL}/userDocument`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                      <span>Upload Documents</span>
                    </a>
                  </>
                ) : (
                  <a href={`${process.env.PUBLIC_URL}/myprofile`} className="dt-mobile-link" onClick={() => setMobileDrawerOpen(false)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 7 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 7 2.6h.1A2 2 0 0 1 9 1h.1" transform="translate(2 2) scale(.86)"/></svg>
                    <span>Profile &amp; Documents</span>
                  </a>
                )}
                {isSuper && (
                  <button
                    className="dt-mobile-link w-100 text-start btn-reset"
                    onClick={() => { setMobileDrawerOpen(false); setShowPlan(true); }}
                  >
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                    <span>Subscription Plan</span>
                  </button>
                )}
              </div>
            </div>

            {/* Logout Footer & Powered by DenTTrack */}
            <div className="dt-mobile-drawer__footer">
              <button
                className="dt-btn dt-btn--ghost w-100 text-danger border-danger border-opacity-25 mb-2 py-2"
                onClick={() => { setMobileDrawerOpen(false); setShowLogout(true); }}
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                Sign Out
              </button>

              {/* Powered by DenTTrack Box */}
              <div className="text-center mb-2">
                <div
                  className="d-inline-flex flex-column align-items-center justify-content-center px-4 py-2 bg-white rounded-3 shadow-sm border"
                  style={{ borderRadius: "10px" }}
                >
                  <span style={{ fontSize: "10px", color: "#64748B", textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700, marginBottom: "4px" }}>
                    Powered by
                  </span>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/logo.png`}
                    alt="DenTTrack"
                    style={{ maxHeight: "20px", maxWidth: "120px", objectFit: "contain" }}
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                </div>
              </div>

              {/* Social Icons */}
              <div className="d-flex justify-content-center gap-3 text-muted" style={{ opacity: 0.85 }}>
                <a href="https://facebook.com" target="_blank" rel="noreferrer" className="text-secondary" title="Facebook">
                  <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-secondary" title="Twitter">
                  <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.936 9.936 0 0024 4.59z"/></svg>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="text-secondary" title="LinkedIn">
                  <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-secondary" title="Instagram">
                  <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noreferrer" className="text-secondary" title="YouTube">
                  <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                </a>
              </div>
            </div>
          </nav>
        </>
      )}

      {confirmLogout()}
    </div>
  );
};

export default Header;
